import * as actionTypes from '../../customerAreaActionTypes';
import { Configuration } from '@greenkub-fronts/shared/interface';
import { getCurrentProject } from '../../customer-area.slice';
import { formatToMinimalistConfig } from '../../utils/configurationHelpers';
import { addPositiveMessage } from '@greenkub-fronts/domain/snackbar';
import { initCurrentProject } from '../initCurrentProject/init-current-project.use-case';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const persistProcessedOptions = createAsyncThunk(
  'persistProcessedOptions',
  async (
    data: {},
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    const currentProject = getCurrentProject(getState());

    const processOption = getState().customerArea.processedOptions;

    if (!currentProject) {
      return;
    }

    const tmpChosenStudioList =
      currentProject?.configurations[0].chosenStudioList;

    const configuration: Partial<Configuration> = {
      chosenStudioList: tmpChosenStudioList,
      chosenOptionLists: [],
    };

    if (
      processOption.accompagnement &&
      typeof processOption.accompagnement !== 'boolean'
    ) {
      configuration.chosenOptionLists?.push(processOption.accompagnement);
    }
    if (
      processOption.aideDechargement &&
      typeof processOption.aideDechargement !== 'boolean'
    ) {
      configuration.chosenOptionLists?.push(processOption.aideDechargement);
    }
    if (processOption.bardage && typeof processOption.bardage !== 'boolean') {
      configuration.chosenOptionLists?.push(processOption.bardage);
    }
    if (
      processOption.forfaitCoaching &&
      typeof processOption.forfaitCoaching !== 'boolean'
    ) {
      configuration.chosenOptionLists?.push(processOption.forfaitCoaching);
    }
    if (
      processOption.menuiserieAnthra &&
      typeof processOption.menuiserieAnthra !== 'boolean'
    ) {
      configuration.chosenOptionLists?.push(processOption.menuiserieAnthra);
    }
    if (processOption.pergola && typeof processOption.pergola !== 'boolean') {
      configuration.chosenOptionLists?.push(processOption.pergola);
    }
    if (
      processOption.taillePergola &&
      typeof processOption.taillePergola !== 'boolean'
    ) {
      configuration.chosenOptionLists?.push(processOption.taillePergola);
    }
    if (
      processOption.tailleTerrasse &&
      typeof processOption.tailleTerrasse !== 'boolean'
    ) {
      configuration.chosenOptionLists?.push(processOption.tailleTerrasse);
    }
    if (processOption.terrasse && typeof processOption.terrasse !== 'boolean') {
      configuration.chosenOptionLists?.push(processOption.terrasse);
    }
    if (
      processOption.toitureVege &&
      typeof processOption.toitureVege !== 'boolean'
    ) {
      configuration.chosenOptionLists?.push(processOption.toitureVege);
    }

    const minimalistConfig = formatToMinimalistConfig([configuration]);

    dispatch({
      type: actionTypes.PROCESS_OPTIONS_PERSISTING,
    });

    await dispatch(
      extra.apiSlice.endpoints.patchCustomerConfigurations.initiate({
        projectId: currentProject.id,
        configurations: minimalistConfig,
      })
    );

    dispatch(
      addPositiveMessage(
        "Un nouveau devis remplacera sous peu l'ancien parmi vos documents"
      )
    );

    dispatch({
      type: actionTypes.PROCESS_OPTIONS_PERSISTED,
    });

    await dispatch(
      extra.apiSlice.endpoints.getAllCustomerProjects.initiate(undefined, {
        forceRefetch: true,
      })
    );

    dispatch(initCurrentProject({ refetch: true }));
  }
);
